<script>
  import { ArrowRight, Gamepad2, Keyboard, Orbit, Radar, Users } from "@lucide/svelte";
</script>

<section id="screen-menu" class="screen menu-screen" aria-label="Main menu">
        <div class="menu-panel">
          <!-- First-choice mode screen -->
          <div id="menu-panel-modes" class="menu-panel-view" data-menu-panel="modes">
            <div class="home-hero">
              <div>
                <p class="quest-eyebrow">Command deck // online</p>
                <h1>CHOOSE YOUR MISSION</h1>
                <p class="tagline">
                  Four arcade legends. One connected expedition. Your next run starts here.
                </p>
              </div>
              <div class="signal-card" aria-label="Fleet status">
                <span class="signal-dot" aria-hidden="true"></span>
                <span>Fleet network</span>
                <strong>READY</strong>
              </div>
            </div>

            <label class="field">
              <span>Callsign</span>
              <input id="input-name" type="text" maxlength="16" placeholder="Pilot" autocomplete="off" />
            </label>

            <div class="mode-grid" role="group" aria-label="Game modes">
              <button
                id="btn-mode-arcade"
                class="mode-card mode-card-primary"
                type="button"
                aria-label="Arcade — classic cabinet games"
              >
                <span class="mode-card-icon" aria-hidden="true"><Gamepad2 size={26} strokeWidth={1.7} /></span>
                <span class="mode-card-kicker">High-score runs</span>
                <span class="mode-card-title">Arcade</span>
                <span class="mode-card-desc">Pick a cabinet. Learn the pattern. Claim the board.</span>
                <span class="mode-card-action">Browse 4 cabinets <ArrowRight size={16} aria-hidden="true" /></span>
              </button>
              <button
                id="btn-mode-adventure"
                class="mode-card mode-card-primary"
                type="button"
                aria-label="Adventure — Beyond the Belt expedition"
                aria-describedby="expedition-hint"
              >
                <span class="mode-card-icon adventure-icon" aria-hidden="true"><Orbit size={27} strokeWidth={1.7} /></span>
                <span class="mode-card-kicker">Solo expedition</span>
                <span class="mode-card-title">Adventure</span>
                <span class="mode-card-desc">Chart routes, survive encounters, and reach the anomaly.</span>
                <span class="mode-card-action">Launch Beyond the Belt <ArrowRight size={16} aria-hidden="true" /></span>
              </button>
              <button
                id="btn-mode-strategy"
                class="mode-card mode-card-sub coming-soon"
                type="button"
                disabled
                aria-disabled="true"
                aria-label="Strategy — coming soon"
              >
                <span class="mode-card-icon" aria-hidden="true"><Radar size={22} strokeWidth={1.6} /></span>
                <span class="mode-card-kicker">In development</span>
                <span class="mode-card-title">Strategy</span>
                <span class="mode-card-desc">Fleet command is still in the lab.</span>
              </button>
            </div>
            <p id="expedition-hint" class="dim expedition-hint">
              Adventure launches a New Expedition: solo campaign map · fuel routes · bounded combat
            </p>

            <!-- Hidden: Adventure still drives the existing expedition create path -->
            <button id="btn-expedition" class="sr-only" type="button" tabindex="-1">New Expedition</button>

            <div class="home-tools">
            <div class="join-module">
              <div class="module-heading"><Users size={18} aria-hidden="true" /><span>Join a crew</span></div>
              <div class="divider"><span>Enter a friend's room code</span></div>

            <label class="field">
              <span>Invite code</span>
              <input id="input-code" type="text" maxlength="4" placeholder="ABCD" autocomplete="off" class="code" />
            </label>
            <div class="btn-row">
              <button id="btn-join" class="btn" type="button">Join Room <ArrowRight size={16} aria-hidden="true" /></button>
            </div>
            </div>

            <div class="highscores arcade-leaders" id="highscores">
              <div class="hs-header">
                <div>
                  <p class="module-kicker">Top five · solo</p>
                  <h3>Arcade leaders</h3>
                </div>
                <span class="leaderboard-note">Scores stay ranked by cabinet</span>
              </div>
              <div class="arcade-leader-grid">
                <section class="mini-leaderboard" aria-labelledby="home-hs-asteroids-title">
                  <h4 id="home-hs-asteroids-title">Asteroids</h4>
                  <ol id="home-hs-asteroids" class="hs-list"></ol>
                  <p id="home-hs-asteroids-empty" class="dim hs-empty hidden">No scores yet.</p>
                </section>
                <section class="mini-leaderboard" aria-labelledby="home-hs-lander-title">
                  <h4 id="home-hs-lander-title">Lunar Lander</h4>
                  <ol id="home-hs-lander" class="hs-list"></ol>
                  <p id="home-hs-lander-empty" class="dim hs-empty hidden">No scores yet.</p>
                </section>
                <section class="mini-leaderboard" aria-labelledby="home-hs-invaders-title">
                  <h4 id="home-hs-invaders-title">Space Invaders</h4>
                  <ol id="home-hs-invaders" class="hs-list"></ol>
                  <p id="home-hs-invaders-empty" class="dim hs-empty hidden">No scores yet.</p>
                </section>
                <section class="mini-leaderboard" aria-labelledby="home-hs-missile-title">
                  <h4 id="home-hs-missile-title">Missile Command</h4>
                  <ol id="home-hs-missile" class="hs-list"></ol>
                  <p id="home-hs-missile-empty" class="dim hs-empty hidden">No scores yet.</p>
                </section>
              </div>
            </div>

            <div class="controls-help">
              <div class="module-heading"><Keyboard size={18} aria-hidden="true" /><h3>Flight controls</h3></div>
              <ul>
                <li><kbd>←</kbd><kbd>→</kbd> / <kbd>A</kbd><kbd>D</kbd> rotate</li>
                <li><kbd>↑</kbd> / <kbd>W</kbd> thrust</li>
                <li><kbd>Space</kbd> fire</li>
                <li class="hyperspace-control">
                  <span><kbd>Shift</kbd> / <kbd>H</kbd> hyperspace</span>
                  <button
                    id="btn-hyperspace-info"
                    class="control-info"
                    type="button"
                    aria-label="Explain hyperspace risks"
                    aria-haspopup="dialog"
                    aria-controls="hyperspace-dialog"
                  >?</button>
                </li>
                <li class="map-help"><kbd>←</kbd><kbd>→</kbd> cycle routes · <kbd>Enter</kbd> select (map)</li>
              </ul>
            </div>
            </div>
          </div>

          <!-- Arcade cabinet selector -->
          <div id="menu-panel-cabinets" class="menu-panel-view hidden" data-menu-panel="cabinets" hidden>
            <div class="menu-nav-row">
              <button id="btn-back-cabinets" class="btn ghost btn-menu-back" type="button">← Back</button>
            </div>
            <p class="quest-eyebrow">Arcade</p>
            <h1>SELECT CABINET</h1>
            <p class="tagline">Step up to a classic. More machines arrive as the fleet expands.</p>

            <div class="cabinet-grid" role="group" aria-label="Arcade cabinets">
              <button
                id="btn-cabinet-asteroids"
                class="cabinet-card"
                type="button"
                aria-label="Asteroids cabinet"
              >
                <span class="cabinet-card-title">Asteroids</span>
                <span class="cabinet-card-desc">Solo belt runs or co-op rooms</span>
              </button>
              <button
                id="btn-cabinet-lander"
                class="cabinet-card"
                type="button"
                aria-label="Lunar Lander cabinet"
              >
                <span class="cabinet-card-title">Lunar Lander</span>
                <span class="cabinet-card-desc">Ten ranked precision landings</span>
              </button>
              <button
                id="btn-cabinet-invaders"
                class="cabinet-card"
                type="button"
                aria-label="Space Invaders cabinet"
              >
                <span class="cabinet-card-title">Space Invaders</span>
                <span class="cabinet-card-desc">Ranked solo wave defense</span>
              </button>
              <button
                id="btn-cabinet-missile"
                class="cabinet-card"
                type="button"
                aria-label="Missile Command cabinet"
              >
                <span class="cabinet-card-title">Missile Command</span>
                <span class="cabinet-card-desc">Ranked solo city defense</span>
              </button>
            </div>
          </div>

          <!-- Asteroids cabinet: solo + co-op -->
          <div id="menu-panel-asteroids" class="menu-panel-view hidden" data-menu-panel="asteroids" hidden>
            <div class="menu-nav-row">
              <button id="btn-back-asteroids" class="btn ghost btn-menu-back" type="button">← Back</button>
            </div>
            <p class="quest-eyebrow">Arcade · Asteroids</p>
            <h1>ASTEROIDS</h1>
            <p class="tagline">Clear the belt alone, or open a co-op room and share the invite code.</p>

            <div class="btn-row">
              <button id="btn-solo" class="btn primary" type="button">Play Solo</button>
              <button id="btn-create" class="btn" type="button">Create Co-op Room</button>
            </div>
            <div class="highscores compact-board">
              <div class="hs-header">
                <h3>Asteroids high scores</h3>
                <div class="hs-tabs" role="tablist" aria-label="Asteroids leaderboard">
                  <button type="button" class="hs-tab active" data-tab="individuals" role="tab">Pilots</button>
                  <button type="button" class="hs-tab" data-tab="teams" role="tab">Teams</button>
                </div>
              </div>
              <ol id="asteroids-hs-list" class="hs-list"></ol>
              <p id="asteroids-hs-empty" class="dim hs-empty hidden">No Asteroids scores yet.</p>
            </div>
          </div>

          <!-- Lunar Lander cabinet -->
          <div id="menu-panel-lander" class="menu-panel-view hidden" data-menu-panel="lander" hidden>
            <div class="menu-nav-row">
              <button id="btn-back-lander" class="btn ghost btn-menu-back" type="button">← Back</button>
            </div>
            <p class="quest-eyebrow">Arcade · Lunar Lander</p>
            <h1>LUNAR LANDER</h1>
            <p class="tagline">Master ten increasingly difficult descents. Every run is practice; every touchdown counts.</p>

            <div class="btn-row">
              <button
                id="btn-lander-challenge"
                class="btn primary"
                type="button"
                aria-describedby="challenge-hint"
                aria-label="Play Lunar Lander Arcade"
              >
                Play
              </button>
            </div>
            <p id="challenge-hint" class="dim expedition-hint">
              10 levels · ranked · soft landing 40/25/20 · fuel remaining 15% · value pads 1×/2×/3×
            </p>
            <div class="highscores compact-board">
              <h3>Lunar Lander · lander_arcade_v2</h3>
              <ol id="lander-hs-list" class="hs-list"></ol>
              <p id="lander-hs-empty" class="dim hs-empty hidden">No ranked landings yet.</p>
            </div>
          </div>

          <!-- Space Invaders cabinet -->
          <div id="menu-panel-invaders" class="menu-panel-view hidden" data-menu-panel="invaders" hidden>
            <div class="menu-nav-row">
              <button id="btn-back-invaders" class="btn ghost btn-menu-back" type="button">← Back</button>
            </div>
            <p class="quest-eyebrow">Arcade · Space Invaders</p>
            <h1>SPACE INVADERS</h1>
            <p class="tagline">Hold the line against descending formations in a fixed, server-authoritative arcade ruleset.</p>

            <div class="btn-row">
              <button
                id="btn-invaders-play"
                class="btn primary"
                type="button"
                aria-label="Play Space Invaders"
              >
                Play Space Invaders
              </button>
            </div>
            <p class="dim expedition-hint">Ranked · invaders_arcade_v1 · standard · solo</p>
            <div class="highscores compact-board">
              <h3>Space Invaders · invaders_arcade_v1</h3>
              <ol id="invaders-hs-list" class="hs-list"></ol>
              <p id="invaders-hs-empty" class="dim hs-empty hidden">No defenders ranked yet.</p>
            </div>
          </div>

          <!-- Missile Command cabinet -->
          <div id="menu-panel-missile" class="menu-panel-view hidden" data-menu-panel="missile" hidden>
            <div class="menu-nav-row">
              <button id="btn-back-missile" class="btn ghost btn-menu-back" type="button">← Back</button>
            </div>
            <p class="quest-eyebrow">Arcade · Missile Command</p>
            <h1>MISSILE COMMAND</h1>
            <p class="tagline">
              Track inbound warheads and detonate interceptors in the sky. Defend six cities with three batteries.
              Unused ammo carries into the next wave, so precise commanders build deeper reserves.
            </p>

            <div class="btn-row">
              <button
                id="btn-missile-play"
                class="btn primary"
                type="button"
                aria-label="Play Missile Command"
              >
                Play Missile Command
              </button>
            </div>
            <p class="dim expedition-hint">
              Ranked · missile_arcade_v2 · standard · solo · mouse aim · click / Space fire
            </p>
            <div class="highscores compact-board">
              <h3>Missile Command · missile_arcade_v2</h3>
              <ol id="missile-hs-list" class="hs-list"></ol>
              <p id="missile-hs-empty" class="dim hs-empty hidden">No commanders ranked yet.</p>
            </div>
          </div>

          <p id="menu-error" class="error menu-error" role="alert"></p>

          <dialog
            id="hyperspace-dialog"
            class="risk-dialog"
            aria-labelledby="hyperspace-dialog-title"
            aria-describedby="hyperspace-dialog-detail"
          >
            <div class="risk-dialog-mark" aria-hidden="true">!</div>
            <div>
              <p class="risk-dialog-eyebrow">Emergency maneuver</p>
              <h2 id="hyperspace-dialog-title">HYPERSPACE IS NOT SAFE</h2>
              <p id="hyperspace-dialog-detail">
                Hyperspace relocates your ship to a random position, stops your momentum,
                and gives you one second of collision protection.
              </p>
              <p class="risk-dialog-warning">
                Every jump has a <strong>5% malfunction risk</strong> that destroys your ship
                immediately and costs one life.
              </p>
              <p class="dim">Use it when the danger around you is worse than the jump.</p>
              <form method="dialog">
                <button class="btn primary" type="submit">Understood</button>
              </form>
            </div>
          </dialog>
        </div>
      </section>
